import { Link } from 'react-router-dom';
import { ROUTE_META } from '@/lib/seo';

const label = {
  fontFamily: 'var(--wft-mono)',
  fontSize: '10.5px',
  letterSpacing: '0.1em',
  textTransform: 'uppercase' as const,
};

/**
 * 404. Rather than a dead end, it lists the routes that do exist — the same
 * registry the sitemap is built from, so the two can never disagree.
 */
export function NotFoundRoute() {
  const routes = ROUTE_META.filter((m) => !m.noindex);

  return (
    <main
      id="wft-main"
      style={{
        minHeight: '100vh',
        background: 'var(--wft-bg-0)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 24px',
      }}
    >
      <div style={{ width: '100%', maxWidth: '640px' }}>
        <p style={{ ...label, color: 'var(--wft-accent)', margin: '0 0 12px' }}>Error 404</p>
        <h1
          style={{
            fontFamily: 'var(--wft-display)',
            fontSize: 'clamp(26px, 5vw, 38px)',
            lineHeight: 1.15,
            letterSpacing: '-0.01em',
            color: 'var(--wft-ink-0)',
            margin: '0 0 14px',
          }}
        >
          No panel at this address.
        </h1>
        <p
          style={{
            fontFamily: 'var(--wft-sans)',
            fontSize: '15px',
            lineHeight: 1.65,
            color: 'var(--wft-ink-1)',
            margin: '0 0 28px',
            maxWidth: '52ch',
          }}
        >
          The route you asked for is not one this site serves. Everything it does serve is listed
          below.
        </p>

        <nav aria-label="Site sections">
          <ul
            style={{
              listStyle: 'none',
              margin: 0,
              padding: 0,
              display: 'grid',
              gap: '1px',
              background: 'var(--wft-line)',
              border: '1px solid var(--wft-line)',
              borderRadius: '3px',
              overflow: 'hidden',
            }}
          >
            {routes.map((r) => (
              <li key={r.path} style={{ background: 'var(--wft-bg-1)' }}>
                <Link
                  to={r.path}
                  className="wft-i6"
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '12px',
                    padding: '13px 16px',
                    minHeight: '44px',
                    color: 'var(--wft-ink-0)',
                  }}
                >
                  <span style={{ ...label, color: 'var(--wft-accent)', flex: 'none' }}>
                    {r.path}
                  </span>
                  <span
                    style={{
                      fontFamily: 'var(--wft-sans)',
                      fontSize: '13px',
                      color: 'var(--wft-ink-2)',
                    }}
                  >
                    {r.title.replace(/ — World Finance Terminal$/, '')}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </main>
  );
}
